import React from 'react';
import InputLabel from '@material-ui/core/InputLabel/InputLabel';
import Select from '@material-ui/core/Select/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import { configStatusesTranslateMap } from '../../../config/statuses';
import {useTranslation} from "react-i18next";

const ZajavlSelect = ({zajavls, selectedValue, handleChange}) => {
    const { t } = useTranslation();

    const selectBody = zajavls.map(zajavl => {
        return <MenuItem key={zajavl.id} value={zajavl.id}>
            {`${t('application_dated')} ${zajavl.create_datetime}`}
            &nbsp;
            ({
                configStatusesTranslateMap[zajavl.status]
                    ? t(configStatusesTranslateMap[zajavl.status])
                    : t('unknown_status')})
        </MenuItem>;
    });
    const label = t('select_application');
    return (
        <FormControl size="small" variant="outlined" fullWidth>
            <InputLabel>{label}</InputLabel>
            <Select value={selectedValue ? selectedValue : 0}
                    onChange={handleChange}
                    label={label}
            >
                {selectBody}
            </Select>
        </FormControl>
    );
};
export default ZajavlSelect;
